import ApiClient from "./ApiClient";
import SelectItem from "../models/shared/SelectItem";
import SchoolType from "../models/school-type/SchoolType";
import SchoolTypeEnum from "../models/school-type/SchoolTypeEnum";

export default class SchoolTypeApiClient {
  apiClient: ApiClient;
  urlPrefix: string = "school-types/";

  constructor() {
    this.apiClient = new ApiClient();
  }

  async getSchoolTypes() {
    const schoolTypes: SchoolType[] = await this.apiClient.get(this.urlPrefix);

    return schoolTypes;
  }

  async getSchoolTypeSelectItems() {
    const schoolTypes: SchoolType[] = await this.apiClient.get(this.urlPrefix);
    const schoolTypeItems: SelectItem<SchoolTypeEnum>[] = schoolTypes.map(
      st => {
        return { value: st.id, text: st.name } as SelectItem<SchoolTypeEnum>;
      }
    );

    return schoolTypeItems;
  }
}
